export default "__VITE_ASSET__d0637bbb__"